module.exports = __webpack_public_path__ + "static/appInto05-471c73cb5c0ea486fd3ce53aee784b3a.png";